/** Part C — Merchant link resolution modal. */
import React, { useCallback } from 'react';
import { Building2 } from 'lucide-react';
import { LinkResolutionModal } from './ResolutionModalBase';

export default function MerchantLinkResolutionModal({ open, onOpenChange, deal, onResolved }) {
  const filter = useCallback((c) => !!c.is_merchant, []);
  return (
    <LinkResolutionModal
      open={open}
      onOpenChange={onOpenChange}
      deal={deal}
      title="Link Merchant"
      description="Select an existing merchant contact for this deal."
      icon={<Building2 className="h-4 w-4" />}
      fieldKey="company_id"
      contactType="merchant"
      contactFilter={filter}
      onResolved={onResolved}
      testidPrefix="resolve-merchant-link"
    />
  );
}
